module.exports = __webpack_public_path__ + "assets/70.jpg?8b5313ecc1f04d297000b8f388133451";